module.exports = __webpack_public_path__ + "static/media/ball_4_6.ed3fee70.mp3";